<template>
<!--    申请人证据信息-->
    <div class="applicantBox">
        <div class="evidence">
            <h4>申请人证据</h4>
            <p style="border: 1px solid #3b63f6"></p>
        </div>
<!--        1营业执照-->
        <div class="matter">
            <div class="fileContent">
                <p> <span style="color: #f56c6c;margin-right: 4px;">*</span> 营业执照:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="10"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {handleRemove(file, fileList, upload_data.doc_type)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf,.png,.jpg,.zip,.rar"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="upload_data"
                    :file-list="application"
                    :on-progress="onProgress"

            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--      2法定代表人身份证正反面  -->
        <div class="matter">
            <div class="fileContent">
                <p><span style="color: #f56c6c;margin-right: 4px;">*</span>法定代表人身份证正反面:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="10"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {deleteId(file, fileList, id_card.doc_type)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf,.png,.jpg,.zip,.rar"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="id_card"
                    :file-list="idList"
                    :on-progress="onProgress"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
<!--        3其他-->
        <div class="matter">
            <div class="fileContent">
                <p>其他:</p>
            </div>
            <el-upload
                    ref='upload'
                    class="inline"
                    :limit="10"
                    :on-preview="handlePreview"
                    :on-remove="(file, fileList) => {handledelete(file, fileList, other_data.doc_type)}"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    accept=".pdf,.png,.jpg,.zip,.rar"
                    :headers="headers"
                    :action="url"
                    name="file"
                    :data="other_data"
                    :file-list="otherList"
                    :on-progress="onProgress"
            >
                <el-button class="custom">
                    上传
                </el-button>
            </el-upload>
        </div>
        <div class="save" style="margin: auto;">
            <el-button  class="save" @click="save">保存</el-button>
        </div>
    </div>
</template>

<script>
    import { applicantCertificate, plea, respondent, saveEvidence } from '../../../api/arbitrationCase';

    export default {
        name: 'applicantPage',
        data(){
            return{
                url:process.env.VUE_APP_BASE_API+'/api/upload_com_id_file',
                headers:{
                    "Authorization": sessionStorage.getItem("token"),
                    "Comid": sessionStorage.getItem("shenfen"),
                    "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
                },
                //营业执照
                upload_data:{
                    doc_type:'1',  //1营业执照；2法定代表人身份证正反面；3其他
                },
                //身份证
                id_card:{
                    doc_type:'2',  //1营业执照；2法定代表人身份证正反面；3其他
                },
                //其他
                other_data:{
                    doc_type:'3',  //1营业执照；2法定代表人身份证正反面；3其他
                },
                //营业执照
                zhizhao:{
                    psd_codes:[],
                },
                //法定代表人身份证正反面
                zhengfanmian:{
                    psd_codes:[],
                },
                //其他证据
                qita:{
                    psd_codes:[],
                },
                application:[],
                idList:[],
                otherList:[],
            }
        },
        methods:{
            //点击文件列表事件
            handlePreview(file){
                if (file.all_url){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.all_url);
                }else if (file.response){
                    const link = document.createElement("a"); //自己创建的a标签
                    link.href = file.response.data.all_url+'?v='+Math.random();
                    link.target="_blank"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(file.response.data.all_url);
                }
            },
            // 删除 营业执照
            handleRemove(file, fileList,lawOffice){
                this.zhizhao.psd_codes.forEach((item,index)=>{
                    if (item==file.psd_code){
                        this.zhizhao.psd_codes.splice(index,1)
                    }
                })
            },
            //删除身份证
            deleteId(file, fileList,lawOffice){
                this.zhengfanmian.psd_codes.forEach((item,index)=>{
                    if (item==file.psd_code){
                        this.zhengfanmian.psd_codes.splice(index,1)
                    }
                })
            },
            //移除 其他
            handledelete(file,fileList,lawOffice){
                this.qita.psd_codes.forEach((item,index)=>{
                    if (item==file.psd_code){
                        this.qita.psd_codes.splice(index,1)
                    }
                })
            },
            //上传成功
            handleSuccess(response, file, fileList){
                if (response.code==200){
                    if (response.data.doc_type==1){
                        this.zhizhao.psd_codes.push(response.data.psd_code)
                    }else if(response.data.doc_type==2){
                        this.zhengfanmian.psd_codes.push(response.data.psd_code)
                    }else if(response.data.doc_type==3){
                        this.qita.psd_codes.push(response.data.psd_code)
                    }
                    this.$message.success(response.msg);
                }else {
                    this.$message.error(response.msg);
                }

            },
            //限制条数
            handleExceed(files, fileList){
                if (fileList.length>=10){
                    this.$message.error('只能上传10个文件');
                }
            },
            //上传文件进度未上传完成时添加loading
            onProgress({ percent }) {
                if (percent!==100){
                    this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                }else {
                    this.$loading().close()
                }
            },
            //保存
            save(){
                saveEvidence(this.zhizhao,this.zhengfanmian,this.qita).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            this.headers.Comid=JSON.parse(sessionStorage.getItem("shenfen")).com_id
            applicantCertificate().then(res=>{
                if(res.code==200){
                    //营业执照
                    if (res.data.zhizhao!=''&&res.data.zhizhao!=undefined){
                        this.application=res.data.zhizhao
                        res.data.zhizhao.forEach(item=>{
                            this.zhizhao.psd_codes.push(item.psd_code)
                        })
                    }
                    //身份证
                    if (res.data.zhengfanmian!=''&&res.data.zhengfanmian!=undefined){
                        this.idList=res.data.zhengfanmian
                        res.data.zhengfanmian.forEach(item=>{
                            this.zhengfanmian.psd_codes.push(item.psd_code)
                        })
                    }
                    //其他
                    if (res.data.qita!=''&&res.data.qita!=undefined){
                        this.otherList=res.data.qita
                        res.data.qita.forEach(item=>{
                            this.qita.psd_codes.push(item.psd_code)
                        })
                    }
                }else {
                    this.$message.error(res.msg)
                }

            })
        }
    };
</script>

<style scoped>
    .applicantBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .evidence{
        width: 100px;
        text-align: center;
        color: #1e57dc;
    }
    .evidence>h4{
        margin-bottom: 5px;
    }
    .matter{
        display: flex;
        align-items: center;
        margin: 10px 0px;
    }
    .inline{
        /*width: 50%;*/
        height: 32px;
        margin: 0px 15px;
        display: flex;
        align-items: center;
    }
    /deep/.el-upload--text{
        margin: 0px 20px;
        width: 60px;
        line-height: 30px;
        height: 100%;
        border: 0px;
        color: #fff;
    }
    .custom{
        background-color: #3f5cf7;
        color: #fff;
    }
    .save{
        width: 120px;
        background-color: #3b63f6;
        color: #fff;
        height: 40px;
        border-radius: 5px;
    }
    .fileContent>p{
        width: 170px;
        color: #666666;
        font-size: 14px;
    }
    /deep/.el-upload-list{
        /*width: 150px;*/
        display: flex;
        align-items: flex-end;
    }
</style>
